import { Component } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
	selector: 'pk-broker-layered-purchasing-feedback-form-modal',
	standalone: false,
	templateUrl: './layered-purchasing-feedback-form-modal.component.html',
	styleUrl: './layered-purchasing-feedback-form-modal.component.scss',
})
export class LayeredPurchasingFeedbackFormModalComponent {
	public selectedChoice: string | null = null;
	/** Mockup: after Submit, body/footer switch to thank-you + Close. */
	public submitted = false;

	constructor(private activeModal: BsModalRef) {}

	public submit(): void {
		this.submitted = true;
	}

	public close(): void {
		this.activeModal.hide();
	}
}
